import { render, staticRenderFns } from "./CefrScoreEditor.vue?vue&type=template&id=a667eefe&scoped=true&"
import script from "./CefrScoreEditor.vue?vue&type=script&lang=js&"
export * from "./CefrScoreEditor.vue?vue&type=script&lang=js&"
import style0 from "./CefrScoreEditor.vue?vue&type=style&index=0&id=a667eefe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a667eefe",
  null
  
)

export default component.exports